import React, { createContext, useState } from 'react';

// Create the CustomContext
const PrivilegeContext = createContext();

export const PrivilegeContextProvider = ({ children }) => {
  // const [privileges, setPrivileges] = useState(null);

  const [privileges, setPrivileges] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('currentHospitalAdmin'));
      return saved && saved.privileges_profiles ? saved.privileges_profiles : null;
    } catch (error) {
      console.error("Failed to parse privileges from localStorage:", error);
      return null;
    }
  });

  // This function can be used to update privileges when the login API is called
  const setUserPrivileges = (privilegesData) => {
    setPrivileges(privilegesData);
  };

  return (
    <PrivilegeContext.Provider value={{ privileges, setUserPrivileges }}>
      {children}
    </PrivilegeContext.Provider>
  );
};

export default PrivilegeContext;
